/* tslint:disable */
/* eslint-disable */
/**
 * cellera-backend API spec
 * Backend Service for Cellera | [swagger.json](cellera/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { WearableConnectionProviderStatusDto } from './WearableConnectionProviderStatusDto';
import {
    WearableConnectionProviderStatusDtoFromJSON,
    WearableConnectionProviderStatusDtoFromJSONTyped,
    WearableConnectionProviderStatusDtoToJSON,
    WearableConnectionProviderStatusDtoToJSONTyped,
} from './WearableConnectionProviderStatusDto';

/**
 * 
 * @export
 * @interface WearableConnectionStatusResponseDto
 */
export interface WearableConnectionStatusResponseDto {
    /**
     * UI wearable-only sections should be hidden when this value is false
     * @type {boolean}
     * @memberof WearableConnectionStatusResponseDto
     */
    isConnected: boolean;
    /**
     * 
     * @type {Array<WearableConnectionProviderStatusDto>}
     * @memberof WearableConnectionStatusResponseDto
     */
    providers: Array<WearableConnectionProviderStatusDto>;
}

/**
 * Check if a given object implements the WearableConnectionStatusResponseDto interface.
 */
export function instanceOfWearableConnectionStatusResponseDto(value: object): value is WearableConnectionStatusResponseDto {
    if (!('isConnected' in value) || value['isConnected'] === undefined) return false;
    if (!('providers' in value) || value['providers'] === undefined) return false;
    return true;
}

export function WearableConnectionStatusResponseDtoFromJSON(json: any): WearableConnectionStatusResponseDto {
    return WearableConnectionStatusResponseDtoFromJSONTyped(json, false);
}

export function WearableConnectionStatusResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): WearableConnectionStatusResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'isConnected': json['isConnected'],
        'providers': ((json['providers'] as Array<any>).map(WearableConnectionProviderStatusDtoFromJSON)),
    };
}

export function WearableConnectionStatusResponseDtoToJSON(json: any): WearableConnectionStatusResponseDto {
    return WearableConnectionStatusResponseDtoToJSONTyped(json, false);
}

export function WearableConnectionStatusResponseDtoToJSONTyped(value?: WearableConnectionStatusResponseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'isConnected': value['isConnected'],
        'providers': ((value['providers'] as Array<any>).map(WearableConnectionProviderStatusDtoToJSON)),
    };
}

